import { Box, BoxProps, Spinner } from "@chakra-ui/react"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { useEffect, useMemo } from "react"
import { getChangeLogEmbedUrl } from "./utils"

function ChangelogIframe({
  onClose,
  ...boxProps
}: {
  onClose: () => void
} & BoxProps) {
  const { me } = usePathwrightContext()
  const iframeSrcURL = useMemo(() => new URL(getChangeLogEmbedUrl(me)), [me])

  // Close when the user clicks the "x" button on the Path App path.
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.origin !== iframeSrcURL.origin) return
      if (event.data?.action === "close") {
        onClose()
      }
    }

    window.addEventListener("message", handler)
    return () => {
      window.removeEventListener("message", handler)
    }
  }, [iframeSrcURL])

  return (
    <Box
      pos="absolute"
      inset="10px"
      rounded="xl"
      overflow="hidden"
      {...boxProps}
    >
      <Box
        pos="absolute"
        inset={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        h="full"
        w="full"
      >
        <Spinner color="white" size="xl" />
      </Box>
      <Box
        as="iframe"
        src={iframeSrcURL.toString()}
        pos="relative"
        h="full"
        w="full"
      />
    </Box>
  )
}

export default ChangelogIframe
